var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"netBankingContainer"},[_c('div',{staticClass:"depositAmount mb-5"},[_c('div',[_vm._v(" Depositing Amount ")]),_c('div',[_vm._v(" ₹"+_vm._s(_vm._f("localeAmount")(_vm.amount))+" ")])]),(_vm.accountInfo)?_c('PaymentDetailCard',{attrs:{"paymentDetails":_vm.getPaymentDetails,"selectedPortfolio":_vm.portfolio}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }